
/**
 * lookup table for Colors
 * @param name 
 */
export function getHexByColorName(name: string): {color: string, text: string} {
    let colors: {[key: string]: {color: string, text: string}} = {};

    colors['apfelgrün'] = {color: "#009E84", text: "#fff"};
    colors['gelb'] = {color: "#EAE500", text: "#000"};
    colors['hellgrün'] = {color: "#7BAA20", text: "#fff"};
    colors['lila'] = {color: "#4E147C", text: "#fff"};
    colors['rosa'] = {color: "#FFACAC", text: "#fff"};
    colors['schwarz'] = {color: "#000", text: "#fff"};
    colors['blau'] = {color: "#3374B5", text: "#fff"};
    colors['dunkelblau'] = {color: "#0C2650", text: "#fff"};
    colors['navy'] = {color: "#0C2650", text: "#fff"};
    colors['babyblau'] = {color: "#ADC3D2", text: "#fff"};
    colors['grün'] = {color: "#006400", text: "#fff"};
    colors['jadegrün'] = {color: "#25AE93", text: "#fff"};
    colors['orange'] = {color: "#F77F0E", text: "#fff"};
    colors['rot'] = {color: "#B72527", text: "#fff"};
    colors['braun'] = {color: "#855200", text: "#fff"};
    colors['dunkelgrau'] = {color: "#757575", text: "#fff"};
    colors['dunkelrot'] = {color: "#B72527", text: "#fff"};
    colors['hellgrau'] = {color: "#Cccccc", text: "#000"};
    colors['babyrosa'] = {color: "#E5730A", text: "#fff"};
    colors['pink'] = {color: "#FF45D1", text: "#fff"};
    colors['royal'] = {color: "#00008B", text: "#fff"};
    colors['royalblau'] = {color: "#00008B", text: "#fff"};
    colors['weiss'] = {color: "#fff", text: "#000"};
    colors['burgunder'] = {color: "#4F222B", text: "#fff"};
    colors['dunkelgrün'] = {color: "#0B3D0B", text: "#fff"};
    colors['kirschrot'] = {color: "#851E35", text: "#fff"};
    colors['türkis'] = {color: "#23A4D5", text: "#fff"};
    colors['khaki'] = {color: "#8E8D82", text: "#fff"};
    colors['grau'] = {color: "#999999", text: "#fff"};
    colors['natur'] = {color: "#F2F2D5", text: "#fff"};
    colors['mocca'] = {color: "#523731", text: "#fff"};
    colors['marone'] = {color: "#87714B", text: "#fff"};
    colors['altrosa'] = {color: "#B37F8B", text: "#fff"};
    colors['flieder'] = {color: "#C192B6", text: "#fff"};
    colors['dunkellila'] = {color: "#4E3B55", text: "#fff"};
    colors['mint'] = {color: "#83BBA4", text: "#fff"};
    colors['fjord'] = {color: "#527C8C", text: "#fff"};
    colors['petrol'] = {color: "#254F4B", text: "#fff"};
    colors['silber'] = {color: "#969794", text: "#fff"};
    colors['anthrazit'] = {color: "#3F4335", text: "#fff"};
    colors['beige'] = {color: "#CEB893", text: "#fff"};

    if (colors.hasOwnProperty(name.toLowerCase())) {
        return colors[name.toLowerCase()];
    }

    return {color: "linear-gradient(135deg, #f0b7a1 0%,#8c3310 50%,#752201 51%,#bf6e4e 100%);", text: "#fff"};
}